var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11101",
    "data-name": "Group 11101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.27,
    height: 93.229,
    viewBox: "0 0 74.27 93.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3126",
    "data-name": "Rectangle 3126",
    width: 74.27,
    height: 93.229,
    fill: "#77ffa5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10744",
    "data-name": "Group 10744",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28978",
    "data-name": "Path 28978",
    d: "M73.884,30.755a4.642,4.642,0,0,0-4.052-2.79H48.494L54.4,5.875A4.626,4.626,0,0,0,49.929,0H17.306a4.667,4.667,0,0,0-4.66,3.449L.168,50.056a4.646,4.646,0,0,0,.777,4.052,4.7,4.7,0,0,0,3.741,1.821H22.718L14.274,87.34a4.676,4.676,0,0,0,7.985,4.344L73.039,35.758a4.666,4.666,0,0,0,.845-5M28.255,71.221l5-18.642a4.657,4.657,0,0,0-4.486-5.872H10.875L20.848,9.323H43.834L37.912,31.414a4.673,4.673,0,0,0,4.66,5.872H59.2Z",
    transform: "translate(0 -0.002)",
    fill: "#77ffa5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.97689a7cba6c3d4fcf4162ffe830b2c7.svg";
export { ForwardRef as ReactComponent };